/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import classnames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const Section = ({children, className='', ...rest}) => {
    const classes = classnames("card__section")+" "+className;
    return <Box padding='large' className={classes} {...rest}>{children}</Box>;
}

export default Section;
    